export default __webpack_public_path__ + "static/media/ic-art-mental.e090c8b5.svg";